document.addEventListener('DOMContentLoaded', function () {
  const customer_prices = document.querySelector('.customer-prices').innerHTML.trim();
  
  // Parse the string format "sku1:price1,sku2:price2,..." into an object
  const customer_prices_map = {};
  if (customer_prices && customer_prices !== '[]') {
    customer_prices.split(',').forEach(pair => {
      const [sku, price] = pair.split(':');
      if (sku && price) {
        customer_prices_map[sku] = parseFloat(price);
      }
    });
  }

  // Keep track of processed cards
  const processedCards = new Set();

  // Debounce function
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  // Process cards function
  const processCards = debounce(() => {
    const priceElements = document.querySelectorAll('.js-pagination-result .card--product-custom .price--bottom');
    priceElements.forEach((priceElement) => {
      // Skip if already processed
      if (processedCards.has(priceElement)) return;
      
      const sku = priceElement.dataset.sku;
      if (!sku) return;

      const price = customer_prices_map[sku];
      if (price !== undefined) {
        const customerPrice = priceElement.querySelector('.price__current');
        if (customerPrice) {
          const formattedPrice = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(price);
          customerPrice.innerHTML = formattedPrice;
          processedCards.add(priceElement);
        }
      }
    });
  }, 250); // 250ms debounce

  // Create a MutationObserver to watch for price elements
  const observer = new MutationObserver((mutations) => {
    let shouldProcess = false;
    
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        shouldProcess = true;
      }
    });

    if (shouldProcess) {
      processCards();
    }
  });

  // Start observing the document with the configured parameters
  observer.observe(document.body, { childList: true, subtree: true });

  // Initial processing
  processCards();
});